import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setSelectedUser = (payload) => ({
    type: CONST.SET_SELECTED_USER,
    payload: payload
});

/*****************************************************
 * Fetch User
 ****************************************************/
export const fetchUserSuccess = (payload) => ({
    type: CONST.FETCH_USER_SUCCESS,
    payload: payload
});

export const fetchUserFailed = (payload) => ({
    type: CONST.FETCH_USER_FAILED,
    payload: payload
});

export const fetchUser = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/users/${filters['id']}`, { params: filters }),
        [fetchUserSuccess],
        [fetchUserFailed]
    );
};

/*****************************************************
 * Fetch Users
 ****************************************************/
export const fetchUsersSuccess = (payload) => ({
    type: CONST.FETCH_USERS_SUCCESS,
    payload: payload
});

export const fetchUsersFailed = (payload) => ({
    type: CONST.FETCH_USERS_FAILED,
    payload: payload
});

export const fetchUsers = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/users', { params: filters }),
        !filters?.paginate && !filters?.direct ? [fetchUsersSuccess] : [],
        !filters?.paginate && !filters?.direct ? [fetchUsersFailed] : []
    );
};


export const checkEmailExists = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/auth/check-email-availability', data),
        [],
        []
    );
};

/*****************************************************
 * Send Verification Email
 ****************************************************/
export const sendVerificationEmailSuccess = (payload) => ({
    type: CONST.SEND_VERIFICATION_EMAIL_SUCCESS,
    payload: payload
});

export const sendVerificationEmailFailed = (payload) => ({
    type: CONST.SEND_VERIFICATION_EMAIL_FAILED,
    payload: payload
});

export const sendVerificationEmail = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/send-verification-email', data),
        [sendVerificationEmailSuccess],
        [sendVerificationEmailFailed]
    );
};

/*****************************************************
 * Verify User
 ****************************************************/
export const doVerifySuccess = (payload) => ({
    type: CONST.VERIFY_EMAIL_SUCCESS,
    payload: payload
});

export const doVerifyFailed = (payload) => ({
    type: CONST.VERIFY_USER_FAILED,
    payload: payload
});

export const doVerify = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/verify', data),
        [doVerifySuccess],
        [doVerifyFailed]
    );
};

/*****************************************************
 * Forgot Password
 ****************************************************/
export const doForgotPasswordSuccess = (payload) => ({
    type: CONST.FORGOT_PASSWORD_SUCCESS,
    payload: payload
});

export const doForgotPasswordFailed = (payload) => ({
    type: CONST.FORGOT_PASSWORD_FAILED,
    payload: payload
});

export const doForgotPassword = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/forgot-password', data),
        [doForgotPasswordSuccess],
        [doForgotPasswordFailed]
    );
};

/*****************************************************
 * Password Reset
 ****************************************************/
export const doResetPasswordSuccess = (payload) => ({
    type: CONST.RESET_PASSWORD_SUCCESS,
    payload: payload
});

export const doResetPasswordFailed = (payload) => ({
    type: CONST.RESET_PASSWORD_FAILED,
    payload: payload
});

export const doResetPassword = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/auth/reset-password', data),
        [doResetPasswordSuccess],
        [doResetPasswordFailed]
    );
};

/*****************************************************
 * Add User
 ****************************************************/
export const addUserSuccess = (payload) => ({
    type: CONST.ADD_USER_SUCCESS,
    payload: payload
});

export const addUserFailed = (payload) => ({
    type: CONST.ADD_USER_FAILED,
    payload: payload
});

export const addUser = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/users', data),
        [addUserSuccess],
        [addUserFailed]
    );
};

/*****************************************************
 * Update User
 ****************************************************/
export const updateUserSuccess = (payload) => ({
    type: CONST.UPDATE_USER_SUCCESS,
    payload: payload
});

export const updateUserFailed = (payload) => ({
    type: CONST.UPDATE_USER_FAILED,
    payload: payload
});

export const updateUser = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/users/${data['id']}`, data),
        [updateUserSuccess],
        [updateUserFailed]
    );
};

/*****************************************************
 * Delete User
 ****************************************************/
export const deleteUserSuccess = (payload) => ({
    type: CONST.DELETE_USER_SUCCESS,
    payload: payload
});

export const deleteUserFailed = (payload) => ({
    type: CONST.DELETE_USER_FAILED,
    payload: payload
});

export const deleteUser = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/users/${data['id']}`),
        [deleteUserSuccess],
        [deleteUserFailed]
    );
};

/*****************************************************
 * Change Password
 ****************************************************/
export const changePasswordSuccess = (payload) => ({
    type: CONST.CHANGE_PASSWORD_SUCCESS,
    payload: payload
});

export const changePasswordFailed = (payload) => ({
    type: CONST.CHANGE_PASSWORD_FAILED,
    payload: payload
});

export const changePassword = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/users/change-password/${data['id']}`, data),
        [changePasswordSuccess],
        [changePasswordFailed]
    );
};

/*****************************************************
 * Add User to Department
 ****************************************************/
export const addUserToDepartmentSuccess = (payload) => ({
    type: CONST.ADD_USER_TO_DEPARTMENT_SUCCESS,
    payload: payload
});

export const addUserToDepartmentFailed = (payload) => ({
    type: CONST.ADD_USER_TO_DEPARTMENT_FAILED,
    payload: payload
});

export const addUserToDepartment = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/users/${data['id']}`, data),
        [addUserToDepartmentSuccess],
        [addUserToDepartmentFailed]
    );
};


/*****************************************************
 * Remove User from Department
 ****************************************************/
export const removeUserFromDepartmentSuccess = (payload) => ({
    type: CONST.REMOVE_USER_FROM_DEPARTMENT_SUCCESS,
    payload: payload
});

export const removeUserFromDepartmentFailed = (payload) => ({
    type: CONST.REMOVE_USER_FROM_DEPARTMENT_FAILED,
    payload: payload
});

export const removeUserFromDepartment = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/users/${data['id']}/remove-department`, data),
        [removeUserFromDepartmentSuccess],
        [removeUserFromDepartmentFailed]
    );
};

/*****************************************************
 * Resend Invitation
 ****************************************************/
export const resendInvitationSuccess = (payload) => ({
    type: CONST.RESEND_INVITATION_SUCCESS,
    payload: payload
});

export const resendInvitationFailed = (payload) => ({
    type: CONST.RESEND_INVITATION_FAILED,
    payload: payload
});

export const resendInvitation = ({dispatch, userId}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post(`core/users/${userId}/resend-invitation`),
        [resendInvitationSuccess],
        [resendInvitationFailed]
    );
};
